import useFeatureToggles from 'utils/hooks/use-feature-toggles'

const A11Y_FLAGS = ['seedPrPoc', 'WCAG', 'wcag'] as const

export const useA11yEnabled = () => {
  const { featureToggles, isLoadingFeatureTogglesData } = useFeatureToggles()

  const a11yEnabled = A11Y_FLAGS.some(flag => featureToggles?.[flag] === true)

  return {
    a11yEnabled,
    isResolved: !isLoadingFeatureTogglesData
  }
}
